export default class HtmlObjectMapItemCreator {

    getElement = (object, isRegionItem = false) => {
        const mainContainer = document.createElement('a');
        mainContainer.classList.add("object", "object--popup");
        mainContainer.href = object.url;

        mainContainer.appendChild(this.getObjectSlider(object));

        const data = document.createElement('div');
        data.classList.add("object__data");

        const closeButton = this.getCloseButton();
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            const switchButton = document.getElementById('switchToData');
            mainContainer.remove();
            switchButton.style.removeProperty("bottom");
            return;
        });

        data.appendChild(closeButton);
        data.appendChild(this.getPriceContainer(object, isRegionItem));
        data.appendChild(this.getObjectHeader(object));
        if (!isRegionItem) {
            data.appendChild(this.getObjectData(object));
        }
        mainContainer.appendChild(data);

        return mainContainer;
    }

    getObjectData = (object) => {
        const objectData = document.createElement('div');
        objectData.classList.add("object-data");
        objectData.innerHTML = object.features;

        return objectData;
    }

    getObjectHeader = (object) => {
        const objectHeader = document.createElement('div');
        objectHeader.classList.add("object-header");

        const h2 = document.createElement('h2');
        h2.innerHTML = `${object.title}`;

        const h3 = document.createElement('h3');
        h3.innerHTML = `<svg viewBox="64 64 896 896" focusable="false" data-icon="environment" aria-hidden="true"><path d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"></path></svg> ${object.address}`;

        objectHeader.appendChild(h2);
        objectHeader.appendChild(h3);

        return objectHeader;
    }

    getPriceContainer = (object, isRegionItem) => {
        const priceContainer = document.createElement('div');
        priceContainer.classList.add("price");

        let pricePerStayP;
        if (!isRegionItem) {
            const pricePerStaySpan = document.createElement('span');
            pricePerStaySpan.innerHTML = object.pricePerStay;

            pricePerStayP = document.createElement('p');
            pricePerStayP.classList.add("price__per-stay");
            pricePerStayP.appendChild(pricePerStaySpan);
        }

        const pricePerNightP = document.createElement('p');
        pricePerNightP.classList.add("price__per-night");
        if (isRegionItem) {
            priceContainer.innerText = object.pricePerNightText;
        }
        pricePerNightP.innerHTML += object.pricePerNight;
        priceContainer.appendChild(pricePerNightP);

        if (!isRegionItem) {
            priceContainer.appendChild(pricePerStayP);
        }

        return priceContainer;
    }

    getCloseButton = () => {
        const closeButton = document.createElement('span');
        closeButton.classList.add("close");
        closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.45711 4.04289C5.06658 3.65237 4.43342 3.65237 4.04289 4.04289C3.65237 4.43342 3.65237 5.06658 4.04289 5.45711L10.1932 11.6074L4.04345 17.7572C3.65293 18.1477 3.65293 18.7809 4.04345 19.1714C4.43398 19.5619 5.06714 19.5619 5.45767 19.1714L11.6074 13.0216L17.7572 19.1714C18.1477 19.5619 18.7809 19.5619 19.1714 19.1714C19.5619 18.7809 19.5619 18.1477 19.1714 17.7572L13.0216 11.6074L19.172 5.45711C19.5625 5.06658 19.5625 4.43342 19.172 4.04289C18.7814 3.65237 18.1483 3.65237 17.7577 4.04289L11.6074 10.1932L5.45711 4.04289Z" fill="#8C8C8C"/></svg>`;

        return closeButton;
    }

    getObjectSlider = (object) => {
        const slider = document.createElement('div');
        slider.classList.add("object__slider");

        const sliderObject = document.createElement('div');
        sliderObject.classList.add("object-slider");

        const sliderObjectItem = document.createElement('div');
        sliderObjectItem.classList.add("object-slider__item");

        const image = document.createElement('img');
        image.src = object.image;

        sliderObjectItem.appendChild(image);
        sliderObject.appendChild(sliderObjectItem);
        slider.appendChild(sliderObject);

        return slider;
    }
}